<div id="chart">
  <div [chart]="chartObject" id="graph"></div>
  <app-chart-legend [hidden]="!showLegend" [legends]="legends" [hasBenchmarks]="hasBenchmarks"></app-chart-legend>
</div>
